module.exports = __webpack_public_path__ + "img/BD.b37f6c88.svg";